import { IStep } from "./StepTwo";
import QuestionCard from "../../Question-card/Question-card";
import { IAvailableQuestions, IQuestionResponse } from "../../CommonProps";

export interface IStepTwo extends IStep {
  handleQuestionResponse: (obj: IQuestionResponse) => void;
  availableQuestions: IAvailableQuestions[];
  isDisabled: boolean;
  isLoading: boolean;
}

const StepThree = ({ handleNext, handleBack, handleQuestionResponse, availableQuestions, step, isDisabled, isLoading }: IStepTwo) => {

  return (
    <>
      <div className="assessment-card-container">
        {availableQuestions.map((question) => {
          return <QuestionCard question={question} handleQuestionResponse={handleQuestionResponse} />;
        })}
      </div>
      <div className="btn-container marginTop ">
        <button onClick={handleBack} className="outlined-button">
          Back
        </button>
        {!isLoading ? (
          <button disabled={isDisabled} onClick={handleNext} className="button-dark">
            Next
          </button>
        ) : (
          <button className="button-dark">
            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </button>
        )}
      </div>
    </>
  );
};

export default StepThree;
